import React, { useEffect, useContext, useReducer, useState } from "react";
import { dataFetchReducer } from "../../Utils/requestUtils";
import AuthContext from "../../../context/auth-context"
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from '@material-ui/core'
import ErrorBoundary from '../../Utils/ErrorBoundary'
import AccountPersons from "./AccountPersons/AccountPersons";
import AccountResume from "./AccountResume/AccountResume";
import { useTranslation } from 'react-i18next';

function DeviceManagerAccount() {
	let history = useHistory()
	let user_data = useContext(AuthContext).user_data

	if (!user_data.roles.includes("read_device_manager")) {
		history.push("")
	}

	let { account_key } = useParams();

	const { t } = useTranslation()

	const [updatePage, setUpdatePage] = useState(false);

	const [device_manager_account, dispatchDeviceManagerAccount] = useReducer(
		dataFetchReducer,
		{ fetchedData: null, isLoading: true, isError: false }
	)

	useEffect(() => {
		dispatchDeviceManagerAccount({ type: "data_fetch_init" })
		const timer = setTimeout(() => {
			axios.get('/dash/device_manager/account/' + account_key).then(response => {
				dispatchDeviceManagerAccount({
					type: "data_fetch_success",
					payload: response.data
				})
			}).catch(error => {
				if ((error.response || {}).status === 403) dispatchDeviceManagerAccount({ type: "data_fetch_failure_403" })
				else if ((error.response || {}).status === 404) dispatchDeviceManagerAccount({ type: "data_fetch_failure_404" })
				else dispatchDeviceManagerAccount({ type: "data_fetch_failure" })
			})
		}, 500);
		return () => {
			clearTimeout(timer)
		}
	}, [account_key, updatePage])

	if (device_manager_account.fetchedData) {
		return (
			<div style={{ minWidth: "900px", overflow: "auto", paddingBottom: "30px" }}>
				<div className="analysisCardContainer" style={{ display: "flex" }}>
					<ErrorBoundary>
						<div>
							<div className={["blueText", "titleSize"].join(" ")} style={{ margin: "5px 0px" , marginBottom: "30px" }}>
								{t("account") + ": " + device_manager_account.fetchedData.external_id}
							</div>
						</div>
					</ErrorBoundary>
				</div>
				<div className="analysisCardContainer">
					<ErrorBoundary>
						<AccountResume Account={device_manager_account.fetchedData} />
					</ErrorBoundary>
				</div>

				<div className="analysisCardContainer">
					<ErrorBoundary>
						<AccountPersons AccountPersons={device_manager_account.fetchedData.persons} setUpdatePage={setUpdatePage} />
					</ErrorBoundary>
				</div>
			</div>
		)
	}
	else if (device_manager_account.isLoading) {
		return (
			<div style={{ width: "auto" }}>
				<div className='circularProgressCenter'>
					<CircularProgress />
				</div>
			</div>
		)
	}
	else if (device_manager_account.isError) {
		return (
			<div style={{ height: "80vh", display: "flex" }}>
				<p className={["blueText", "titleSize"].join(" ")} style={{ margin: "auto", textAlign: "center" }}>
					{device_manager_account.errorMessage}
				</p>
			</div>
		)
	}

	return null;
}

export default DeviceManagerAccount;
